const routes = [
    {
        path: '/assinatura_digital/modelos',
        alias: ['/assinatura_digital/modelos/index'],
        component: () => import('../views/Listar')
    },
    {
        path: '/assinatura_digital/modelos/adicionar',
        component: () => import('../views/Adicionar'),
        meta: {
            fullScreen: true,
        },
    },
    {
        path: '/assinatura_digital/modelos/editar/:id',
        component: () => import('../views/Editar'),
        meta: {
            fullScreen: true,
        },
    },
    {
        path: '/assinatura_digital/modelos/gerar_documento/:id',
        component: () => import('../views/GerarDocumento'),
        meta: {
            fullScreen: true,
            semChat: true, // rodapé fixo ficaria embaixo do widget de suporte
        },
    },
    {
        path: '/assinatura_digital/modelos/visualizar/:id',
        component: () => import('../views/Visualizar')
    },
]

export default routes